export enum ApplicationViews {
	Dashboard = 0,
	ConversationBuilder = 1,
	ContentAdministrators = 2,
	Permissions = 3,
	UnitList = 4,
	CategoryManager = 5,
	Components = 6,
	WordManager = 7,
	TagList = 8,
	TagUsageStatistics = 9,
	TagUsageDetails = 10,
	TagSearch = 11,
	NewTextAnalysis = 12,
	ReaderWriterAnalysis = 13,
	TextChangeAnalysis = 14,
	WordCount = 15,
	WordPhraseSearch = 16,
	WordDetails = 17,
	InviteUser = 18,
	Text = 19,
	Unauthorized = 20,
	ObjectiveManager = 21,
	ContentExposure = 22,
	ContentObjective = 23,
	LessonPlanVersion = 24,
	LessonPlanList = 25,
	MasterPlan = 26,
	CommonEntities = 27,
	TeachingActivities = 28,
	Transitions = 29,
	Reports = 30,
	ScopeSequence = 31,
	UnitOverview = 32,
	ComponentObjectives = 33,
	VpcOverview = 34,
	MasterPlanLessonPlanEditor = 36,
	ConversationTemplates = 37,
	Fallback = 38,
	Conversations = 39,
	OpenClose = 40,
	ConversationMasterBuilder = 41,
	ManageChapters = 42,
	ComponentConversation = 43,
	LessonPlanTemplate = 44,
	LessonPlanTemplateEditor = 45,
	REP = 46,
	UtteranceEntities = 47,
	CommonIntents = 48,
	PhonogramManager = 49,
	Media = 49,
	RevisionManager = 51,
	StudentActivities = 52,
	AssetList = 53,
	NonCurriculumComponents = 54,
	FocusWords = 55,
	FocusWordsTab = 56,
	ComponentToObjective = 57,
	MasteryQuestionToObjective = 58,
	FocusWordsByChapter = 59,
	AuditHistory = 60,
	MediaChangeImpact = 61
}

export enum AppViewMode {
	Authorized = 1,
	UnAuthorized = 2,
	NotFound = 3,
	Blank = 4
}

export enum VcsMenuCategory {
	UserManagement = 1,
	ListManagement = 2,
	CurriculumManagement = 3,
	LanguageFunctionManagement = 4,
	TextAnalysis = 5,
	Vocabulary = 6,
	VersionManager = 7,
	LessonPlan = 8,
	CommonEntities = 9,
	Templates = 10,
	ConversationTemplates = 11,
	Components = 12,
	WebsiteAdmin = 13,
	NonCurriculumComponents = 14,
	ActiveLearn = 15,
	MasterTemplate = 44,
	AuditHistory = 16
}

export enum VcsMenuCategoryPermission {
	ContentAdministrators = 1,
	Permissions = 2,
	UnitList = 3,
	CategoryManager = 4,
	Components = 5,
	WordManager = 6,
	TagList = 7,
	TagUsageStatistics = 8,
	TagUsageDetails = 9,
	TagSearch = 10,
	NewTextAnalysis = 11,
	ReaderWriterAnalysis = 12,
	TextChangeAnalysis = 13,
	WordCount = 14,
	WordPhraseSearch = 15,
	WordDetails = 16,
	VersionManager = 17,
	LessonPlanVersion = 18,
	LessonPlanList = 19,
	CommonEntities = 20,
	ObjectiveManager = 21,
	Reports = 22,
	Fallback = 23,
	Conversations = 24,
	OpenClose = 25,
	Text = 26,
	Objectives = 27,
	TeachingPlan = 28,
	ManageChapters = 29,
	ComponentConversation = 30,
	REP = 31,
	QRCodeManager = 32,
	UtteranceEntities = 33,
	CommonIntents = 34,
	LessonPlanTemplate = 36,
	PhonogramManager = 37,
	Media = 35,
	RevisionManager = 38,
	StudentActivities = 39,
	AssetList = 40,
	NonCurriculumComponents = 41,
	FocusWords = 42,
	FocusWordsTab = 43,
	ConversationTemplates = 44,
	AuditHistory = 45
}

export enum InvitationType {
	classTeacher = 0,
	parent = 1,
	campusAdmin = 2,
	schoolAdmin = 3,
	regionAdmin = 4,
	trainingAdmin = 5,
	trainer = 6,
	globalHead = 7,
	systemAdmin = 8,
	subTeacher = 9,
	schoolTeacher = 10,
	accountManager = 11,
	regionTrainer = 12,
	trainingManager = 13,
	contentAdmin = 14
}
export enum STATUS {
	ValidateEmail,
	ExistedEmail,
	InviteNew
}

export enum CurriculumType {
	LittleSEED = 1,
	GrapeSEED = 0
}

export enum ListStates {
	Active,
	Inactive,
	All,
	Pending,
	Future,
	Exposure,
	RWAssigned,
	VSAssigned,
	Queued,
	Processing,
	Scheduled,
	Deleted
}

export enum LanguageSkill {
	VerbalSkill = 0,
	Read = 1,
	Write = 2,
	None = 3
}

export enum ContentStatus {
	New = 0,
	Failed = 1,
	Copied = 2
}

export enum DegreeType {
	Basic,
	Intermediate,
	Expert
}

export enum TreeActionType {
	ExpandAll = 1,
	ExpandLevel1 = 2,
	ExpandLevel2 = 3,
	ExpandLevel3 = 4,
	CollapseAll = 5,
	NewLevel1 = 6
}

export enum ObjectiveActionType {
	New = 1,
	Edit = 2,
	Delete = 3,
	Up = 4,
	Down = 5
}

export enum UnitRenderMode {
	None,
	Line,
	Circle,
	CircleWithLine
}

export enum MethodologyType {
	Classic,
	Digital,
	Remote,
	Independent,
	REP
}

export enum MethodologyTypeEnum {
	All = -1,
	Classic,
	Digital,
	Remote,
	Independent,
	REP
}

export enum LessonPlanVersionStatus {
	Draft = 0,
	Published = 1,
	Internal = 2
}

export enum LessonPlanVersionAction {
	Edit,
	Publish,
	Remove,
	Duplicate,
	Internal,
	Draft
}

export enum LessonPlanVersionActionStatus {
	Add,
	Edit,
	Duplicate
}

export enum LessonPlanTemplateActionStatus {
	Add,
	Edit
}

export enum LessonPlanTemplateRowsType {
	Header,
	TeachingPlan,
	Transition,
	None
}

export enum BatchAction {
	Updating,
	Adding,
	Deleting
}

export enum ContentExposureRelatedItemCategory {
	Component = "Component",
	CustomText = "Custom Text",
	Chapters = "Chapters"
}
export enum ContentExposureRelatedItemType {
	VPC,
	PC,
	PWC,
	CustomText,
	Other,
	Chapter,
	Component
}
export enum CMContentType {
	VPC = 0
}
export enum ContentExposureRelatedItemTypeName {
	VPC = "VPC",
	PC = "PC",
	PWC = "PWC",
	CustomText = "Custom Text",
	Other = "Other",
	Chapter = "Chapter",
	Component = "Component"
}
export enum ContentCategoryEnum {
	//Teacher Manual
	TM = 1,
	//Lesson Planning
	LP = 2,
	//Guide
	GUI = 3,
	//Phonic Audio Files
	PAF = 4,
	//Unit Newsletters
	UNL = 5,
	//Teacher Newsletters
	TNL = 6,
	//REP
	REP = 7,
	//Classroom Materials
	CM = 8,
	//Miscellaneous
	MISC = 9,
	//Support Material
	SM = 10
}
export enum ContentGroupEnum {
	None = -1,
	Song = 0,
	Movie = 1,
	Story = 2,
	Reader = 3,
	Writer = 4,
	VPC = 5
}
export enum ContentGroupNameEnum {
	"Song" = 0,
	"Movie" = 1,
	"Story" = 2,
	"Reader" = 3,
	"Writer" = 4,
	"VPC" = 5
}
export enum ContentTypeEnum {
	TeacherManual = 1,
	UnitLessonPlan = 2,
	IndividualLessonPlan = 3,
	TransitionGuides = 4,
	Guide = 5,
	PhonicAudioFiles = 6,
	UnitNewsletters = 7,
	TeacherNewsletters = 8,
	Student = 10,
	ActivityPages = 11,
	Writer = 12,
	Reader = 13,
	Song = 14,
	ActionActivity = 15,
	Story = 16,
	SharedReading = 17,
	SingleLetterPhonogramCards = 18,
	PhonogramWordCards = 19,
	VocabularyPictureCards = 20,
	ReadWriteWords = 21,
	Color = 22,
	Chant = 23,
	LetsStartReading = 24,
	BigBook = 25,
	MyBody = 26,
	IntroVideo = 29,
	ISeeCards = 35,
	Conversations = 36,
	WritingFunAnswer = 33,
	StoryDictionary = 34,
	StudentAppIntro = 30,
	VocabularyPictureCardReview = 43,
	IndividualLessonPlanPlus = 50
}
export enum LessonPlanAction {
	MoveUp,
	MoveDown,
	Edit,
	Remove
}

export enum QuickViewWindowType {
	Content,
	Exposure
}

export enum BuilderPageType {
	ContentInfo = "contentinfo",
	ExposureInfo = "exposureinfo",
	MasterInfo = "masterinfo"
}

export enum LessonPlanActionStatus {
	Add,
	MoveUp,
	MoveDown,
	Edit,
	Remove
}

export enum AzureAppSlot {
	Production = "production",
	Staging = "staging "
}

export enum ConversationAuthorType {
	Machine = 0,
	User = 1
}

export enum ConversationTemplateType {
	Silent = 1,
	Regular = 2,
	Open = 3,
	Close = 4,
	Other = 5,
	MasterDialog = 6
}

export enum ConversationStatus {
	Active = 0,
	Deleted = 1
}

export enum ConversationTag {
	Title = "Title",
	ChildName = "ChildName",
	DayOfWeek = "DayOfWeek"
}

export enum SpeechRecognizerResultReason {
	RecognizedSpeech = "RecognizedSpeech",
	RecognizingSpeech = "RecognizingSpeech",
	NoMatch = "NoMatch"
}

export enum PathTypes {
	Normal = 1,
	Fallback = 2,
	Silent = 3
}

export enum ParentType {
	Normal = 0,
	Parent = 1,
	Child = 2
}

export enum ExposureConversationState {
	DoesNotExist = 1,
	InComplete = 2,
	Complete = 3
}

export enum ExportType {
	Excel = 1,
	Pdf = 2
}

export enum CommonIntentUtteranceStatus {
	Active = 0,
	Deleted = 1
}

export enum MediaSlot {
	ViewingContent = 1,
	AlternateContent = 2,
	Audio = 3,
	AudioBackground = 4,
	StreamingVideo = 5,
	OfflineVideo = 6,
	TeacherManual = 7,
	Thumbnail = 8,
	ExposureAudio = 9,
	ExposureVideo = 10,
	Image = 11,
	IndividualAudio = 12
}

export enum MediaType {
	NONE = -1,
	PDF = 1,
	MP3 = 2,
	MP4 = 3,
	PNG = 4
}

export enum MediaIconType {
	Pdf = "picture",
	Image = "picture",
	Audio = "play-circle",
	Video = "video-camera"
}

export enum MediaStatus {
	Processing = 1,
	Queued = 2,
	Scheduled = 3,
	Published = 4,
	Archived = 5
}

export enum AccessLevel {
	None = 0,
	Full,
	ReadonlyExport,
	Readonly
}

export enum MediaPlayerContentType {
	mp3 = "audio/mp3",
	mp4Offline = "video/mp4",
	mp4Streaming = "application/vnd.ms-sstr+xml"
}

export enum technologyType {
	azureHtml5JS = "azureHtml5JS",
	flashSS = "flashSS",
	html5FairPlayHLS = "html5FairPlayHLS",
	silverlightSS = "silverlightSS",
	html5 = "html5"
}

export enum InteractionStyles {
	Positive = 1,
	Negative = 2,
	Neutral = 3,
	Indicative = 4,
	Encouraging = 5
}

export enum MediaTypes {
	PDF = 1,
	MP3,
	MP4,
	IMG
}

export enum CustomStatusCodes {
	Forbidden = 4003
}

export enum ErrorType {
	TypeError = 0,
	SizeError = 1,
	NoError = 2
}

export enum Activity {
	Transition = 2,
	Question = 3,
	Conversation = 4
}

export enum TagType {
	Asset = 1
}

export enum NonCurriculumComponentType {
	Unit = 1,
	NonUnit = 2
}

export enum RevisionManagerFiltersEnum {
	All = "All",
	Queued = "Queued",
	Processing = "Processing",
	Scheduled = "Scheduled",
	Published = "Published",
	Deleted = "Deleted (Published)"
}

export enum MediaPublishOptionsEnum {
	ScheduledPublish = 1,
	PublishImmediately = 2
}

export enum SpecialDesignation {
	None = 1,
	VPC = 2,
	ReviewVPC = 3,
	LetterPhonogramCard = 4,
	PhonogramWordCard = 5,
	FocusWords = 6
}

export enum ReaderType {
	Content = 1,
	ChapterContent = 2,
	FocusWord = 3
}

export enum ServerResponseCode {
	Ok = 200,
	Created = 201
}

export enum PermissionOrder {
	UserManagement = 1,
	AuditHistory = 2,
	ListManagement = 3,
	ActiveLearn = 4,
	CurriculumManagement = 5,
	LessonPlan = 6,
	LanguageFunctionManagement = 7,
	Vocabulary = 8,
	TextAnalysis = 9,
	Templates = 10
}
